export const TEXT_POSITIONS = [
    'upperLeft',
    'upperCenter',
    'upperRight',
    'centerLeft',
    'center',
    'centerRight',
    'lowerLeft',
    'lowerCenter',
    'lowerRight',
];

export const IMAGE_POSITIONS = [
    ...TEXT_POSITIONS,
    'overlay',
];

export const POSITION_LABELS = {
    upperLeft: 'Upper left watermark position',
    upperCenter: 'Upper center watermark position',
    upperRight: 'Upper right watermark position',
    centerLeft: 'Center left watermark position',
    center: 'Center watermark position',
    centerRight: 'Center right watermark position',
    lowerLeft: 'Lower left watermark position',
    lowerCenter: 'Lower center watermark position',
    lowerRight: 'Lower right watermark position',
    overlay: 'Full overlay watermark position',
};

export function getTextAnchor(position, w, h, padding, globalK, textSize) {
    switch (position) {
        case 'upperLeft':
            return { x: padding * globalK, y: padding + textSize / 2, hAlign: 'left', vAlign: 'top' };
        case 'upperCenter':
            return { x: w / 2, y: padding + textSize / 2, hAlign: 'center', vAlign: 'top' };
        case 'upperRight':
            return { x: w - padding * globalK, y: padding + textSize / 2, hAlign: 'right', vAlign: 'top' };
        case 'centerLeft':
            return { x: padding * globalK, y: h / 2, hAlign: 'left', vAlign: 'middle' };
        case 'center':
            return { x: w / 2, y: h / 2, hAlign: 'center', vAlign: 'middle' };
        case 'centerRight':
            return { x: w - padding * globalK, y: h / 2, hAlign: 'right', vAlign: 'middle' };
        case 'lowerLeft':
            return { x: padding * globalK, y: h - padding * globalK, hAlign: 'left', vAlign: 'bottom' };
        case 'lowerCenter':
            return { x: w / 2, y: h - padding * globalK, hAlign: 'center', vAlign: 'bottom' };
        case 'lowerRight':
            return { x: w - padding * globalK, y: h - padding * globalK, hAlign: 'right', vAlign: 'bottom' };
        default:
            return { x: 0, y: 0, hAlign: 'left', vAlign: 'top' };
    }
}

export function getImageRect(position, w, h, globalK, wmImage, imageSizePercent) {
    if (position === 'overlay') {
        return { x: 0, y: 0, width: w, height: h, isOverlay: true };
    }

    const landscape = wmImage.width > wmImage.height;
    const imageSize = (Math.round((landscape ? wmImage.width : wmImage.height) * imageSizePercent / 100) || 100) * globalK;
    const k = imageSize / (landscape ? wmImage.width : wmImage.height);
    const drawW = landscape ? imageSize : wmImage.width * k;
    const drawH = landscape ? wmImage.height * k : imageSize;
    const margin = imageSize / 10;

    switch (position) {
        case 'upperLeft':
            return { x: margin, y: margin, width: drawW, height: drawH };
        case 'upperCenter':
            return { x: (w - drawW) / 2, y: margin, width: drawW, height: drawH };
        case 'upperRight':
            return { x: w - drawW - margin, y: margin, width: drawW, height: drawH };
        case 'centerLeft':
            return { x: margin, y: (h - drawH) / 2, width: drawW, height: drawH };
        case 'center':
            return { x: (w - drawW) / 2, y: (h - drawH) / 2, width: drawW, height: drawH };
        case 'centerRight':
            return { x: w - drawW - margin, y: (h - drawH) / 2, width: drawW, height: drawH };
        case 'lowerLeft':
            return {
                x: margin,
                y: h - drawH - (landscape ? drawH / 10 : margin),
                width: drawW,
                height: drawH,
            };
        case 'lowerCenter':
            return {
                x: (w - drawW) / 2,
                y: h - drawH - (landscape ? drawH / 10 : margin),
                width: drawW,
                height: drawH,
            };
        case 'lowerRight':
            return {
                x: w - drawW - margin,
                y: h - drawH - (landscape ? drawH / 10 : margin),
                width: drawW,
                height: drawH,
            };
        default:
            return { x: 0, y: 0, width: drawW, height: drawH };
    }
}
